import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useAuthStore } from './context/auth.store';
import LoginPage        from './pages/LoginPage';
import DashboardPage    from './pages/DashboardPage';
import ReportViewerPage from './pages/ReportViewerPage';
import AdminPage        from './pages/AdminPage';
import UsersPage        from './pages/UsersPage';
import AuditLogPage     from './pages/AuditLogPage';
import EmailFlowPage    from './pages/EmailFlowPage';
import FolderMappingPage from './pages/FolderMappingPage';
import MyEmailReportsPage from './pages/MyEmailReportsPage';
import FlowViewerPage    from './pages/FlowViewerPage';
import SalesOnePager     from './pages/SalesOnePager';
import OneDriveExplorerPage from './pages/OneDriveExplorerPage';
import OneDriveViewerPage   from './pages/OneDriveViewerPage';
import CentralReportsPage   from './pages/CentralReportsPage';
import DistributionAdminPage from './pages/DistributionAdminPage';
import PermissionGovernancePage from './pages/PermissionGovernancePage';
import UserAccessExplorerPage from './pages/UserAccessExplorerPage';
import AiAssistantPage from './pages/AiAssistantPage';
import Layout           from './components/layout/Layout';
import KyroGlobalAssistant from './components/KyroGlobalAssistant';

const Guard = ({ children, adminOnly = false }) => {
  const { isAuthenticated, user, loading } = useAuthStore();
  if (loading) return <div className="splash"><div className="spinner"/></div>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (adminOnly && user?.role !== 'ADMIN') return <Navigate to="/" replace />;
  return children;
};

export default function App() {
  const init = useAuthStore(s => s.init);
  useEffect(() => { init(); }, [init]);

  return (
    <BrowserRouter>
      <Toaster position="top-right" toastOptions={{ duration: 3500 }} />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/one-pager" element={<SalesOnePager />} />
        <Route path="/sales" element={<SalesOnePager />} />
        <Route path="/marketing" element={<SalesOnePager />} />
        <Route path="/flows/:id" element={<Guard><FlowViewerPage /></Guard>} />
        <Route path="/onedrive/viewer/:id" element={<Guard><OneDriveViewerPage /></Guard>} />
        <Route path="/onedrive/view/:id" element={<Guard><OneDriveViewerPage /></Guard>} />
        <Route path="/" element={<Guard><Layout /></Guard>}>
          <Route index element={<DashboardPage />} />
          <Route path="reports/:id" element={<ReportViewerPage />} />
          <Route path="central-reports" element={<CentralReportsPage />} />
          <Route path="onedrive" element={<OneDriveExplorerPage />} />
          <Route path="governance" element={<PermissionGovernancePage />} />
          <Route path="user-access" element={<UserAccessExplorerPage />} />
          <Route path="ai-assistant" element={<AiAssistantPage />} />

          {/* Admin-only routes */}
          <Route path="admin"              element={<Guard adminOnly><AdminPage /></Guard>} />
          <Route path="admin/users"        element={<Guard adminOnly><UsersPage /></Guard>} />
          <Route path="admin/email-flows"  element={<Guard adminOnly><EmailFlowPage /></Guard>} />
          <Route path="admin/folder-map"   element={<Guard adminOnly><FolderMappingPage /></Guard>} />
          <Route path="admin/onedrive"     element={<Guard adminOnly><OneDriveExplorerPage /></Guard>} />
          <Route path="admin/distribution" element={<Guard adminOnly><DistributionAdminPage /></Guard>} />
          <Route path="admin/dispatches"   element={<Guard adminOnly><MyEmailReportsPage /></Guard>} />
          <Route path="admin/audit"        element={<Guard adminOnly><AuditLogPage /></Guard>} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <KyroGlobalAssistant />
    </BrowserRouter>
  );
}
